<template>
    <stu-page class="m-prejobReport" :title="$t('prejob.reportTitle')" icon="inuc-list-chart">
        <section class="report-header">
            <div class="rating">
                <h3>{{$t('prejob.rating')}}</h3>
                <el-rate
                    :value="rating"
                    disabled
                    show-score
                    text-color="#ff9900"
                    score-template="{value}">
                </el-rate>
            </div>
            <div class="knowledge">
                <h3>{{$t('prejob.weakness')}}</h3>
                <template v-if="weakness.length">
                    <span v-for="item in weakness">{{item}}</span>
                </template>
                <template v-else>{{$t('c.none')}}</template>
            </div>
        </section>

        <el-row :gutter="20">
            <el-col :span="9">
                <section class="report-radar" id="radarChart">

                </section>
            </el-col>
            <el-col :span="15">
                <section class="report-chart">
                    <ul class="percent">
                        <li v-for="item in list">
                            <h4>{{item.categoryName}}</h4>
                            <el-progress :text-inside="true" :stroke-width="18" :percentage="item.percentage"></el-progress>
                        </li>
                    </ul>
                    <div class="circle">
                        <el-progress type="circle" :percentage="(average*100).toFixed(0)-0" :width="160" :stroke-width="12" color="#86C39D"></el-progress>
                        <h4>{{$t('prejob.accuracy')}}</h4>
                    </div>
                </section>
            </el-col>
        </el-row>

        <section class="report-result">
            <h3>{{$t('prejob.assessTitle')}}：</h3>
            <div class="result-detail">
                <p :span="10" v-if="assess.perfect">{{$t('prejob.assessPerfect', [assess.perfect])}}</p>
                <p :span="14" v-if="assess.good">{{$t('prejob.assessGood', [assess.good])}}</p>
                <p :span="10" v-if="assess.bad">{{$t('prejob.assessBad', [assess.bad])}}</p>
                <p :span="14">{{$t('prejob.assessCheerUp')}}</p>
            </div>
        </section>
    </stu-page>
</template>

<script>
    import StuPage from '@/components/Stupage';
    import api from '@/api/index';

    let echarts = require('echarts');

    export default {
        components: {
            StuPage,
        },
        data() {
            return {
                average: 0,
                list: [],
                weakness: [],   // 薄弱知识点：正确率不足60%
                assess: {       // 评估结果
                    perfect: [],
                    good: [],
                    bad: []
                }
            }
        },
        computed: {
            rating() {
                return Number( (this.average*5).toFixed(1) )
            },
        },
        created() {
            api.GetEvaluationByStudent().then(res => {
                if (!res.package.record) return;

                this.average = res.package.average;
                this.list = res.package.record;

                this.list.forEach(item => {
                    item.percentage = (item.accuracy * 100).toFixed(0)-0;

                    if (item.accuracy >= 0.8) {
                        this.assess.perfect.push(item.categoryName)
                    } else if (item.accuracy < 0.8 && item.accuracy >= 0.6) {
                        this.assess.good.push(item.categoryName)
                    } else {
                        this.assess.bad.push(item.categoryName)
                        this.weakness.push(item.categoryName)
                    }
                });

                this.assess.perfect = this.assess.perfect.join();
                this.assess.good = this.assess.good.join();
                this.assess.bad = this.assess.bad.join();

                this.drawRadar()
            })
        },
        methods: {
            drawRadar() {
                let options = {
                    tooltip: {},
                    radar: {
                        indicator: this.list.map(item => {
                            return {
                                name: item.categoryName,
                                max: 100
                            }
                        }),
                        radius: '60%',
                        shape: 'circle',
                        name: {
                            textStyle: {
                                color:'#444'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                type: 'dotted'
                            }
                        }
                    },
                    series: [{
                        type: 'radar',
                        data : [
                            {
                                value : this.list.map(item => item.score),
                                name : this.$t('count.score'),
                                lineStyle: {
                                    color: '#fff'
                                },
                                areaStyle: {
                                    normal: {
                                        opacity: 0.8,
                                        color: new echarts.graphic.RadialGradient(0.5, 0.5, 1, [
                                            {
                                                color: '#a4696a',
                                                offset: 0
                                            },
                                            {
                                                color: '#774080',
                                                offset: 0.4
                                            },
                                            {
                                                color: '#4a1795',
                                                offset: 1
                                            }
                                        ])
                                    }
                                }
                            }
                        ]
                    }]
                };

                let myChart = echarts.init(document.getElementById('radarChart'));
                myChart.setOption(options)
            }
        },
        watch: {},
    }
</script>

<style scoped lang="scss">
    @import '../../../style/const';

    $c-title: #333;
    $c-txt: #444;
    $fz-title: 16px;
    $fz-txt: 14px;

    .m-prejobReport {
        section {
            margin-bottom: 20px;
            border-radius: 4px;
            box-shadow: 0 0 8px #ccc;
        }
    }


    .report-header {
        display: flex;
        height: 80px;
        line-height: 80px;
        padding-left: 5%;

        h3 {
            display: inline-block;
            color: $c-title;
            font-size: $fz-title;
        }

        .rating {
            width: 40%;
            .el-rate {
                display: inline-block;
                margin-left: 20px;
                vertical-align: 3px;
                /deep/ .el-rate__icon {
                    font-size: 24px;
                }
            }
        }

        .knowledge {
            width: 60%;
            > span {
                margin-left: 20px;
            }
        }
    }

    .report-radar {
        height: 360px;
    }

    .report-chart {
        height: 360px;
        padding-left: 60px;
        display: flex;
        align-items: center;

        .percent {
            width: 65%;
            padding-right: 50px;
            border-right: 1px dashed #a0a0a0;

            li {
                display: flex;
                margin-bottom: 30px;
                &:last-child {
                    margin-bottom: 0;
                }
                h4 {
                    width: 110px;
                    color: $c-txt;
                }
                .el-progress {
                    flex: 1;
                }
                /deep/ .el-progress-bar__inner {
                    background-image: linear-gradient(90deg,
                        #8ac49d 0%,
                        #69bb9f 40%,
                        #47b1a0 100%),
                    linear-gradient(
                            #5ef8bc,
                            #5ef8bc);
                }
            }
        }

        .circle {
            width: 35%;
            text-align: center;

            > h4 {
                margin-top: 15px;
                font-size: $fz-title;
                color: $c-title;
            }

            /deep/ .el-progress__text {
                transform: scale(1.5);
                margin-top: -8px;
                color: #4fb5a2;
            }
        }
    }

    .report-result {
        display: flex;
        padding: 40px 30px;
        line-height: 2.6;

        .result-detail {
            flex: 1;
        }
    }
</style>
